import { render, staticRenderFns } from "./userData.vue?vue&type=template&id=b08c506a&scoped=true&"
import script from "./userData.vue?vue&type=script&lang=js&"
export * from "./userData.vue?vue&type=script&lang=js&"
import style0 from "./userData.vue?vue&type=style&index=0&id=b08c506a&prod&lang=less&"
import style1 from "./userData.vue?vue&type=style&index=1&id=b08c506a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b08c506a",
  null
  
)

export default component.exports